import { render, staticRenderFns } from "./CardAnalysesCountController.vue?vue&type=template&id=469a77c4&"
import script from "./CardAnalysesCountController.vue?vue&type=script&lang=ts&"
export * from "./CardAnalysesCountController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports